<app-small-card-button
  class="create-card"
  (click)="displayForm()"
  *ngIf="!formDisplay"
>
  <div image>
    <div class="icon">
      <img icon src="/assets/add_icon.svg" />
    </div>
  </div>
  <div title>
    <ng-content select="[title]"></ng-content>
  </div>
</app-small-card-button>

<form
  class="input-card"
  [formGroup]="form"
  (ngSubmit)="submit()"
  *ngIf="formDisplay"
>
  <div>
    <mat-form-field floatLabel="never" class="input-field" appearance="outline">
      <img matPrefix [src]="iconString" alt="" />
      <input
        type="text"
        matInput
        #name="matInput"
        [placeholder]="placeholderString"
        formControlName="workspaceName"
        required
        [maxlength]="maxLength"
        cdkFocusInitial
      />
      <span matSuffix class="input-suffix">{{
        maxLength - name.value.length
      }}</span>
      <mat-error *ngIf="form.controls['workspaceName'].hasError('required')">
        Required
      </mat-error>
      <mat-error *ngIf="form.controls['workspaceName'].hasError('pattern')">
        No special characters
      </mat-error>
      <mat-error *ngIf="form.get('workspaceName').errors?.notUnique">
        Business name already exists! Please pick another one
      </mat-error>
    </mat-form-field>
  </div>

  <div class="action-btns">
    <button
      mat-button
      class="blueOutlineButton logout"
      type="button"
      (click)="cancel()"
    >
      CANCEL
    </button>

    <button
      mat-raised-button
      class="blueButton"
      appearance="outline"
      type="submit"
      [disabled]="!form.valid"
    >
      CREATE
    </button>
  </div>
</form>
